export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8326.da18f4c0.jpg";